import { Box, Typography } from "@mui/material"
import { DialogBox } from "lib/@components/dialogBox"
import Iconify from "minimals-template/components/Iconify"
import { Switch, Case } from "lib/@components/switch"

const ArchiveDialogMode = {
    RESTORE: "restore",
    ARCHIVE: "archive",
    INCOMPLETE: "incomplete",
}

export function ArchiveWorkPackageDialog({ value, archived, incomplete }) {
    const mode = getMode()
    const title = getTitle(mode)
    const isWarning = mode === ArchiveDialogMode.INCOMPLETE
    const titleIcon = isWarning ? "material-symbols:warning-outline" : "material-symbols:info"
    const titleIconSx = isWarning ? { color: "warning.main" } : undefined
    const okColor = isWarning ? "warning" : undefined
    const okCaption = archived ? "Restore" : "Archive"
    const okIcon = archived ? "material-symbols:unarchive-outline" : "material-symbols:archive-outline"

    return (
        <DialogBox
            title={
                <Box display="flex" alignItems="center" gap={1}>
                    <Iconify icon={titleIcon} width={24} height={24} sx={titleIconSx} />
                    <Typography variant="h5">{title}</Typography>
                </Box>
            }
            value={value}
            okCaption={okCaption}
            okColor={okColor}
            okIcon={okIcon}
            cancelColor="text"
            data-cy="archive-dialog"
        >
            <Switch value={mode}>
                <Case when={ArchiveDialogMode.RESTORE}>
                    <Typography mt={3} color="textSecondary">
                        The work package will return to the active work package list.
                    </Typography>
                </Case>
                <Case when={ArchiveDialogMode.ARCHIVE}>
                    <Typography mt={3} color="textSecondary">
                        The work package will move to the archive. Its amends documents and review cycles stay
                        available, but nothing on it can be changed until it is restored.
                    </Typography>
                </Case>
                <Case when={ArchiveDialogMode.INCOMPLETE}>
                    <Typography mt={3} color="textSecondary" data-cy="archive-incomplete-warning">
                        This work package has not been sent to Legacy. Archiving makes it read-only immediately and
                        releases its schedules for other work packages. It can be restored later.
                    </Typography>
                </Case>
            </Switch>
        </DialogBox>
    )

    function getMode() {
        if (archived) return ArchiveDialogMode.RESTORE
        if (incomplete) return ArchiveDialogMode.INCOMPLETE
        return ArchiveDialogMode.ARCHIVE
    }
}

function getTitle(mode) {
    switch (mode) {
        case ArchiveDialogMode.RESTORE:
            return "Restore this work package from the archive?"
        case ArchiveDialogMode.INCOMPLETE:
            return "Archive this unfinished work package?"
        default:
            return "Archive this work package?"
    }
}
